import React, { useState } from "react";

const ExportPage = () => {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const products = [
    {
      title: "Turmeric Fingers",
      desc: "Turmeric fingers are premium, sun-dried rhizomes known for their bold color, rich aroma, and high curcumin profile — ideal for food, pharma, and spice processing workflows.",
      image: "https://5.imimg.com/data5/SELLER/Default/2021/1/MQ/LG/RJ/119906406/turmeric-finger-1000x1000.jpeg"
    },
    { 
      title: "Pulses (Legumes)", 
      desc: "Pulses are nutrient-rich legumes, including beans, lentils, and peas, providing protein, fiber, and essential minerals.",
      image: "https://i.pinimg.com/originals/02/36/58/023658ea46c4f32c3781ae73cc8526fb.jpg"
    },
    { 
      title: "Kiwis", 
      desc: "Kiwis are small, brown, fuzzy fruits with bright green flesh, packed with vitamins and antioxidants.",
      image: "https://healthjade.net/wp-content/uploads/2017/09/kiwi-fruit.jpg"
    },
    {
      title: "Chinese Electronic Decorative Fittings",
      desc: "Premium electronics-based decorative fittings imported from China, including LED panels, smart light fixtures, metallic accents and ambience-enhancing devices — perfect for modern interior design and wholesale supply.",
      image: "https://cdn.prod.website-files.com/612c1e150bbc22010f7961ef/63e3ea8d9e008b1d25d5aae7_sourcing-101-electronics-from-china-epic-sourcing.jpg"
    },
    {
      title: "Chinese Toys",
      desc: "High-quality, factory-manufactured Chinese toys ranging from plastic figures to battery-operated models — cost-efficient, durable, and ideal for wholesale import and retail distribution.",
      image: "./toy.png"
    },
    { 
      title: "Alcoholic Beverages", 
      desc: "Alcoholic beverages include beer, wine, and spirits, enjoyed socially and made from fermented or distilled ingredients.",
      image: "https://barrels.ng/wp-content/uploads/2020/09/Alcoholic-Beverages.-Wines-and-Spirit-In-Lagos.-1536x992.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-amber-50/30 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Title */}
        <div className="text-center mb-16 animate-fade-in-down">
          <div className="inline-block mb-4">
            <div className="w-20 h-1 bg-amber-400 rounded-full mb-2 animate-pulse"></div>
            <div className="w-16 h-1 bg-amber-300 rounded-full animate-pulse" style={{ animationDelay: '0.3s' }}></div>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 transform transition-all duration-700 hover:scale-105">
            <span className="text-gray-800">EXPORT</span>{" "}
            <span className="text-amber-500 bg-gradient-to-r from-amber-500 to-amber-600 bg-clip-text text-transparent animate-pulse-slow">
              PRODUCTS
            </span>
          </h1>

          <p className="text-lg text-gray-600 max-w-2xl mx-auto animate-fade-in-up">
            Discover our premium range of export-quality products sourced from the finest producers
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {products.map((item, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-3 border border-gray-100 hover:border-amber-300 animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >

              {/* IMAGE */}
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
              </div>

              {/* TEXT */}
              <div className="p-6 relative">
                <div className="absolute top-0 right-0 w-20 h-20 bg-amber-100 rounded-full -translate-y-1/2 translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                <h3 className="text-xl font-bold text-gray-800 mb-3 relative z-10 group-hover:text-amber-600 group-hover:translate-x-2 transition-all duration-300">
                  {item.title}
                </h3>

                <p className="text-gray-600 leading-relaxed relative z-10 group-hover:text-gray-700 transition-all duration-500">
                  {item.desc}
                </p>
              </div>

             
            </div>
          ))}
        </div>

      </div>

      {/* Animations */}
      <style>{`
        @keyframes fade-in-down {
          from { opacity: 0; transform: translateY(-30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
        .animate-fade-in-down { animation: fade-in-down 0.8s ease-out forwards; opacity: 0; }
        .animate-fade-in-up { animation: fade-in-up 0.8s ease-out forwards; opacity: 0; }
        .animate-pulse-slow { animation: pulse-slow 3s ease-in-out infinite; }
      `}</style>
    </div>
  );
};

export default ExportPage;